import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            paymentHistory: null,
            subscriptionWindowVisible: false,
            unsubscribeWindowVisible: false,
        }
    },
    getters: {
        paymentHistory: state => state.paymentHistory,
        subscriptionWindowVisible: state => state.subscriptionWindowVisible,
        unsubscribeWindowVisible: state => state.unsubscribeWindowVisible,
    },
    mutations: {
        setPaymentHistory(state, history) {
            state.paymentHistory = history;
        },
        setSubscriptionWindowVisible(state, visible) {
            state.subscriptionWindowVisible = visible;
        },
        setUnsubscribeWindowVisible(state, visible) {
            state.unsubscribeWindowVisible = visible;
        },
    },
    actions: {
        fetchPaymentHistory({ commit }) {
            Vue.prototype.$loading(Vue.prototype.$optionsLoading);

            return ApiService.get('/payment/history')
                .then((response) => {
                    commit('setPaymentHistory', response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    Vue.prototype.$loading({}).close();
                });
        },
        openSubscriptionWindow({ commit }) {
            commit('setSubscriptionWindowVisible', true);
        },
        openUnsubscribeWindow({commit}) {
            commit('setUnsubscribeWindowVisible', true);
        },
        closeSubscriptionWindow({ commit }) {
            commit('setSubscriptionWindowVisible', false);
        },
        closeUnsubscribeWindow({commit}) {
            commit('setUnsubscribeWindowVisible', false);
        }
    }
};
